import {
  SCORECARD_STATUS_ACTIVE,
  SCORECARD_STATUS_COMPLETED,
  SCORECARD_STATUS_DELETED,
  SCORECARD_STATUS_FEEDBACK_REQUESTED,
  SCORECARD_STATUS_GOALS_APPROVED,
  SCORECARD_STATUS_GOALS_PREPARED,
} from 'constants/scorecards';
import { ScorecardStatus } from 'store/interfaces';
import theme from 'styles/theme';

export default function getScorecardStatusColor(status: ScorecardStatus) {
  switch (status) {
    case SCORECARD_STATUS_ACTIVE:
      return theme.palette.grey.A300;
    case SCORECARD_STATUS_COMPLETED:
      return theme.palette.green['400'];
    case SCORECARD_STATUS_FEEDBACK_REQUESTED:
      return theme.palette.yellow['500'];
    case SCORECARD_STATUS_GOALS_PREPARED:
      return theme.palette.purple['300'];
    case SCORECARD_STATUS_GOALS_APPROVED:
      return theme.palette.blue['700'];
    case SCORECARD_STATUS_DELETED:
      return theme.palette.red['100'];
    default:
      return theme.palette.orange['500'];
  }
}
